import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.ReviewerV1MigrationSuccessPopupContent', {
    successPopupMessage: 'Migration successful',
    description: 'You can now start using the Editing on Approval feature.',
    great: 'Great!',
});
